import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ScoreCompanyService from '../../../../../../../core/service'

export const getTrendOfScorePerformance = createAsyncThunk(
  'companyAnalysis/companyScore/performance/getTrendOfScore',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getTrendOfScorePerformance(
        params,
      )
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDistributionPerformance = createAsyncThunk(
  'companyAnalysis/companyScore/performance/getDistributionPerformance',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getDistributionPerformance(
        params,
      )
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
